import i18n from "@/i18n";
// TES-B2C1B2 — compact manager VV context. Presentation only: every
// value comes from the canonical backend VV state (no VV math here).
const UNSUPPORTED_TEXT = {
    get REGULAR_NIGHT_VV() { return i18n.t("wf.VVContextNote.UNSUPPORTED_TEXT.REGULAR_NIGHT_VV", "Regular night VV is not supported yet"); },
    get OFFICE_PROTOCOL() { return i18n.t("wf.VVContextNote.UNSUPPORTED_TEXT.OFFICE_PROTOCOL", "Office protocol VV is not supported"); },
    get PERSONNEL_RESTAURANT_LOCAL_ALTERNATIVE() { return i18n.t("wf.VVContextNote.UNSUPPORTED_TEXT.PERSONNEL_RESTAURANT_LOCAL_ALTERNATIVE", "Local alternative — not covered by MiseOne standard VV"); },
};

export function formatVVMinutes(minutes) {
    if (minutes == null) return "";
    const h = Math.floor(minutes / 60);
    const m = minutes % 60;
    return m ? `${h} h ${m} min` : `${h} h`;
}

export function vvContextMessage(ctx) {
    if (!ctx || !ctx.status) return null;
    switch (ctx.status) {
    case "CALCULABLE": {
        const parts = [`Standard VV · ${ctx.available_count} available`];
        if (ctx.overdue_count > 0) parts.push(`${ctx.overdue_count} overdue`);
        return {
            tone: ctx.available_count === 0 ? "warn" : "info",
            text: parts.join(" · "),
            warning: ctx.available_count === 0
                ? i18n.t("wf.vVContextNote.noVvCurrentlyAvailable", "No VV currently available") : null,
            team: false,
        };
    }
    case "OPENING_STATE_REQUIRED":
        return { tone: "warn", text: "VV opening state required in Team",
            team: true };
    case "VV_PROFILE_UNRESOLVED":
        return { tone: "warn", text: "Configure VV system in Team",
            team: true };
    case "VV_NOT_APPLICABLE":
        return { tone: "muted", text: "VV not applicable (three-shift, no VV)",
            team: false };
    case "UNSUPPORTED_VV_PROFILE":
        return { tone: "muted",
            text: UNSUPPORTED_TEXT[ctx.vv_system] || "VV profile not supported",
            team: false };
    case "REOPENED_PENDING_RECLOSE": {
        const lf = ctx.last_finalized;
        return { tone: "warn",
            text: i18n.t("wf.vVContextNote.periodReopenedVvPendingReclose", "Period reopened — VV pending reclose")
                + (lf ? ` · last finalized ${lf.available_count} available` : ""),
            team: false };
    }
    default:
        return { tone: "warn", text: "VV history incomplete — check Team",
            team: true };
    }
}

const TONE = {
    info: "text-neutral-700",
    warn: "text-amber-700",
    muted: "text-neutral-500",
};

export function VVContextNote({ ctx, testId }) {
    const msg = vvContextMessage(ctx);
    if (!msg) return null;
    return (
        <div data-testid={testId} data-vv-status={ctx.status}
            className={`mt-1 text-[11px] leading-4 ${TONE[msg.tone]}`}>
            <div data-testid={`${testId}-text`}>{msg.text}</div>
            {msg.warning ? (
                <div data-testid={`${testId}-warning`}>{msg.warning}</div>
            ) : null}
            {msg.team ? (
                <a href="/workforce/team" data-testid={`${testId}-team-link`}
                    className="underline underline-offset-2">{i18n.t("wf.vVContextNote.openTeam", "Open Team")}</a>
            ) : null}
        </div>
    );
}

export default VVContextNote;
